/**
 * Builds the Algolia `filters` string that scopes a products search to a category.
 *
 * `productCategoryGroup` (written by the products-import cron) holds the category and all of its
 * parents, so filtering on it also matches products of nested categories. The value is quoted
 * because category ids are numeric strings and would otherwise be read as a numeric filter.
 *
 * Requires `filterOnly(productCategoryGroup)` in `attributesForFaceting` on the `products` index
 * in every Algolia app. Without it the filter matches nothing and the category pages lose both
 * their search results and their facet dropdowns.
 *
 * @param {string} categoryId - The Sanity category id.
 * @returns {string} - The Algolia filters string.
 */
export const categoryGroupFilter = (categoryId) => `productCategoryGroup:"${categoryId}"`

/**
 * Filters out articles that are not available in a specific branch office.
 *
 * @param {Array} articles - The array of articles to filter.
 * @param {string} branchId - The ID of the branch office.
 * @returns {Array} - The filtered array of articles.
 */
export const filterOutArticlesNotAvailableInBranchOffice = (articles, branchId) => {
  articles = articles.filter((article) => {
    return !article.notAvailableInBranchOffices.some((office) => office._ref === `branchOffice-${branchId}`)
  })
  return articles
}
